/**
 * Theme tokens for the ROI calculator.
 * Dark tokens pulled from dashboard.css .dashboard-root.
 * Light tokens pulled from dashboard.css [data-theme="light"].
 */

export interface ROITheme {
  bg: string;
  bgSidebar: string;
  bgCard: string;
  bgChip: string;
  bgChipMedian: string;
  borderChipMedian: string;
  border: string;
  borderHeader: string;
  borderSlider: string;
  borderFeatured: string;
  text: string;
  textSec: string;
  textMuted: string;
  textTitle: string;
  textAccent: string;
  sliderTrack: string;
  sliderThumbBorder: string;
  funnelTrack: string;
  confItemBg: string;
  codeBg: string;
  editInputBg: string;
  editInputBorder: string;
  hoverBg: string;
  badgeBg: string;
  badgeBorder: string;
  badgeText: string;
  badgeDot: string;
  // Canvas colors
  gridLine: string;
  barGradientStart: string;
  barGradientEnd: string;
  axisLabel: string;
}

export const darkTheme: ROITheme = {
  bg: "#0b1326",
  bgSidebar: "#0f172a",
  bgCard: "rgba(19, 27, 46, 0.72)",
  bgChip: "rgba(31, 41, 55, 0.6)",
  bgChipMedian: "rgba(59, 130, 246, 0.1)",
  borderChipMedian: "1px solid rgba(59, 130, 246, 0.2)",
  border: "rgba(255, 255, 255, 0.08)",
  borderHeader: "rgba(255, 255, 255, 0.06)",
  borderSlider: "rgba(255, 255, 255, 0.08)",
  borderFeatured: "rgba(173, 198, 255, 0.16)",
  text: "#dae2fd",
  textSec: "#c2c6d6",
  textMuted: "#64748b",
  textTitle: "#dbeafe",
  textAccent: "#adc6ff",
  sliderTrack: "#1e293b",
  sliderThumbBorder: "#0b1326",
  funnelTrack: "#1f2937",
  confItemBg: "rgba(31, 41, 55, 0.4)",
  codeBg: "rgba(31, 41, 55, 0.5)",
  editInputBg: "rgba(31, 41, 55, 0.8)",
  editInputBorder: "rgba(173, 198, 255, 0.3)",
  hoverBg: "rgba(255, 255, 255, 0.06)",
  badgeBg: "rgba(59, 130, 246, 0.1)",
  badgeBorder: "rgba(173, 198, 255, 0.16)",
  badgeText: "#adc6ff",
  badgeDot: "#3b82f6",
  gridLine: "rgba(255, 255, 255, 0.06)",
  barGradientStart: "rgba(253, 147, 110, 0.85)",
  barGradientEnd: "rgba(129, 129, 255, 0.75)",
  axisLabel: "#64748b",
};

export const lightTheme: ROITheme = {
  bg: "#FAFAFB",
  bgSidebar: "#FFFFFF",
  bgCard: "#FFFFFF",
  bgChip: "#f5f5f5",
  bgChipMedian: "rgba(59, 130, 246, 0.06)",
  borderChipMedian: "1px solid rgba(59, 130, 246, 0.15)",
  border: "#e5e5ea",
  borderHeader: "#e5e5ea",
  borderSlider: "#e5e5ea",
  borderFeatured: "rgba(59, 130, 246, 0.3)",
  text: "#202224",
  textSec: "#666666",
  textMuted: "#999999",
  textTitle: "#202224",
  textAccent: "#3b82f6",
  sliderTrack: "#e5e5ea",
  sliderThumbBorder: "#FFFFFF",
  funnelTrack: "#e5e5ea",
  confItemBg: "#f5f5f5",
  codeBg: "#f5f5f5",
  editInputBg: "#FFFFFF",
  editInputBorder: "#e5e5ea",
  hoverBg: "#f5f5f5",
  badgeBg: "rgba(59, 130, 246, 0.08)",
  badgeBorder: "rgba(59, 130, 246, 0.15)",
  badgeText: "#3b82f6",
  badgeDot: "#3b82f6",
  gridLine: "#e5e5ea",
  barGradientStart: "rgba(253, 147, 110, 0.85)",
  barGradientEnd: "rgba(129, 129, 255, 0.75)",
  axisLabel: "#999999",
};
